 import Hero from '../components/Hero';
import '../styles/Pages.css';
function PowerBI({ setCurrentPage }) {
    return (
      <>
      <Hero title="Power BI Solutions" image="/images/powerbi.jpg" compact />
      <div className="page service-page">
  <div className="service-content">
          <div>
            <img src="/images/powerbi.jpg" alt="Power BI" />
          </div>
          <div className="service-text">
            <h3>Power BI</h3>
            <p>
              Microsoft Power BI is utilized to run reports and surface experiences in view of an
              organization’s information. Power BI can interface with a large number of
              informational indexes, and “cleans up” the data it’s taken care of so it very well
              may be better processed and perceived. The reports and visuals produced from this
              information can then be imparted to different clients.
            </p>
            <p>
              Microsoft Power BI is a powerful tool used to generate reports and uncover insights
              from an organization’s data. It can connect to a wide range of datasets and
              efficiently “clean” the data for easier processing and comprehension. The reports and
              visualizations produced can then be shared with other users, facilitating
              collaboration and informed decision-making.
            </p>
            <button className="cta-button" onClick={() => setCurrentPage('Contact')}>
              Get Started Today
            </button>
          </div>
        </div>
  
        <section className="about-section">
          
        </section>
      </div>
      </>
    );
  }
  
  export default PowerBI;